import {Component, HostListener, OnInit} from '@angular/core';

@Component({
  selector: 'app-footer-page',
  templateUrl: './footer-page.component.html',
  styleUrls: ['./footer-page.component.scss']
})
export class FooterPageComponent implements OnInit {

  scrolledDown = false;
  currentYear = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(): void {
    this.scrolledDown = document.documentElement.scrollTop > 200;
  }

  scrollToTop(): void {
    this.scrolledDown = false;
    window.scrollTo(0, 0);
  }
}
